/**
 * Listenansicht: Mengen-Stepper, Varianten-Auswahl (kompakte Zeile) und AJAX-Warenkorb.
 * Design-Handoff Listenansicht §9. Ein delegierter Listener auf dem Listen-Container.
 * Ohne JS bleibt jede Zeile ein normales Formular (POST /cart/add).
 */
(function () {
  'use strict';

  var SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
  ];

  function status(message) {
    var region = document.querySelector('.plv-status');
    if (region) region.textContent = message;
  }

  function renderCartSections(response) {
    var parsed = {};
    SECTIONS.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host || !response.sections || !response.sections[section.section]) return;
      if (!parsed[section.section]) {
        parsed[section.section] = new DOMParser().parseFromString(response.sections[section.section], 'text/html');
      }
      var target = host.querySelector(section.selector) || host;
      var source = parsed[section.section].querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart:item-added', {
        product: response.hasOwnProperty('items') ? response.items[0] : response
      });
    }
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-plv-error]');
    var labelEl = form.querySelector('[data-plv-label]');
    var original = labelEl ? labelEl.textContent : '';
    if (errorEl) errorEl.textContent = '';
    if (button) button.setAttribute('aria-busy', 'true');

    var formData = new FormData(form);
    formData.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          var message = result.data.description || result.data.message || 'Konnte nicht hinzugefügt werden.';
          if (errorEl) errorEl.textContent = message;
          status(message);
          return;
        }
        renderCartSections(result.data);
        status('Zum Warenkorb hinzugefügt.');
        if (labelEl) {
          labelEl.textContent = 'Hinzugefügt ✓';
          window.setTimeout(function () { labelEl.textContent = original; }, 2000);
        }
      })
      .catch(function () {
        var message = 'Netzwerkfehler — bitte erneut versuchen.';
        if (errorEl) errorEl.textContent = message;
        status(message);
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  }

  /* ===== Kompakte Zeile: Varianten-Auswahl ===== */

  function compactData(row) {
    var script = row.querySelector('[data-plv-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function currentSelection(row, data) {
    var selection = [];
    row.querySelectorAll('.plv-swatch.is-active, .plv-chip.is-active').forEach(function (el) {
      selection[parseInt(el.dataset.plvAxis, 10)] = el.dataset.plvValue;
    });
    return selection;
  }

  function updateCompact(row) {
    var data = compactData(row);
    if (!data) return;
    var selection = currentSelection(row, data);
    var match = data.variants.find(function (v) {
      return selection.every(function (val, i) { return val === undefined || v.options[i] === val; });
    });
    if (!match) return;

    var set = function (sel, fn) {
      var el = row.querySelector(sel);
      if (el) fn(el);
    };
    set('[data-plv-id]', function (el) { el.value = match.id; });
    set('[data-plv-price]', function (el) { el.textContent = match.price; });
    set('[data-plv-compare]', function (el) {
      el.textContent = match.compare || '';
      el.classList.toggle('hidden', !match.compare);
    });
    set('[data-plv-unit]', function (el) {
      el.textContent = match.unit || '';
      el.classList.toggle('hidden', !match.unit);
    });
    set('[data-plv-stock]', function (el) {
      // Nur knapper Bestand bzw. "Nicht lieferbar" - kein "Auf Lager"
      el.classList.remove('plv-compact__stock--low', 'plv-compact__stock--out');
      if (!match.available) {
        el.textContent = 'Nicht lieferbar';
        el.classList.add('plv-compact__stock--out');
        el.classList.remove('hidden');
      } else if (match.qty !== null && match.qty > 0 && match.qty <= (data.lowThreshold || 3)) {
        el.textContent = '● Nur noch ' + match.qty + ' auf Lager';
        el.classList.add('plv-compact__stock--low');
        el.classList.remove('hidden');
      } else {
        el.textContent = '';
        el.classList.add('hidden');
      }
    });
    set('[data-plv-label]', function (el) {
      el.textContent = match.available ? data.addLabel : data.soldOutLabel;
      if (match.available) {
        el.removeAttribute('aria-disabled');
      } else {
        el.setAttribute('aria-disabled', 'true');
      }
    });
    if (match.img) {
      set('[data-plv-image]', function (el) {
        el.removeAttribute('srcset');
        el.src = match.img;
      });
    }

    // Nicht kombinierbare Werte ausgrauen (kein Verstecken, kein Diagonalstrich)
    row.querySelectorAll('.plv-swatch, .plv-chip').forEach(function (el) {
      var axis = parseInt(el.dataset.plvAxis, 10);
      var probe = selection.slice();
      probe[axis] = el.dataset.plvValue;
      var possible = data.variants.some(function (v) {
        return probe.every(function (val, i) { return val === undefined || v.options[i] === val; }) && v.available;
      });
      if (possible) {
        el.removeAttribute('aria-disabled');
      } else {
        el.setAttribute('aria-disabled', 'true');
      }
    });
  }

  /* ===== Delegierte Listener ===== */

  document.addEventListener('click', function (e) {
    var list = e.target.closest('.plv-list');
    if (!list) return;

    var step = e.target.closest('[data-plv-step]');
    if (step) {
      var input = step.parentNode.querySelector('[data-plv-qty]');
      if (input) {
        var min = parseInt(input.min || '1', 10);
        var max = input.max ? parseInt(input.max, 10) : null;
        var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.plvStep, 10);
        if (next < min) next = min;
        if (max !== null && next > max) next = max;
        input.value = next;
      }
      return;
    }

    var option = e.target.closest('.plv-swatch, .plv-chip');
    if (option) {
      if (option.getAttribute('aria-disabled') === 'true') return;
      var row = option.closest('[data-plv-compact]');
      if (!row) return;
      var axis = option.dataset.plvAxis;
      row.querySelectorAll('[data-plv-axis="' + axis + '"]').forEach(function (el) {
        el.classList.remove('is-active');
        el.setAttribute('aria-checked', 'false');
      });
      option.classList.add('is-active');
      option.setAttribute('aria-checked', 'true');
      updateCompact(row);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-plv-form]');
    if (!form || !form.closest('.plv-list')) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;
    addToCart(form);
  });
})();
